import React from 'react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { AppTheme } from '../types';

interface ViewProps { pca: IPublicClientApplication; theme: AppTheme; }

export default function MeetingPanel(_: ViewProps) {
  return (
    <div style={{ padding: 24 }}>
      <h2>Meeting Panel</h2>
      <p>Phase 5 coming soon</p>
    </div>
  );
}
